import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import BrowserHelper from 'src/app/helpers/browser-helper';
import { SubProject } from 'src/app/model/project/sub-project';

@Component({
  selector: 'client-sub-project-on-hold-collapse',
  templateUrl: './client-sub-project-on-hold-collapse.component.html',
  styleUrls: ['./client-sub-project-on-hold-collapse.component.scss']
})
export class ClientSubProjectOnHoldCollapseComponent implements OnInit {
  @Input()
  subProject: SubProject;

  @Input()
  onHoldCollapsed: boolean = true;

  @Output()
  save = new EventEmitter();

  safari: boolean;

  onHoldCollapsedInternal: boolean = false;

  constructor() {}

  ngOnInit(): void {
    this.safari = BrowserHelper.isSafari();
    this.onHoldCollapsedInternal = this.onHoldCollapsed;
  }
}
